export default {
  getRecipesList() {
    return this.http('ExerciseCheck', 'get', 'api/v1/recipes/nice_recipe.json');
  },

  changeRecipesList(options) {
    return this.http('ExerciseCheck', 'post', 'api/v1/recipes', options);
  }
};
